<template>
  <div
    class="flex flex-col gap-8"
    :class="[animatedElementRootClass, animatedElementTransitionClasses]"
  >
    <PdpCheckIconWithLabel label="Fri frakt" />
    <PdpCheckIconWithLabel
      v-if="productPageStore.currentVariant?.StockQuantityDescription"
      :label="productPageStore.currentVariant?.StockQuantityDescription ?? ''"
    />
    <PdpCheckIconWithLabel
      v-if="productPageStore.currentTotalSavingsToDisplay"
      :label="`Du sparar totalt ${productPageStore.currentTotalSavingsToDisplay} kr`"
    />
  </div>
</template>

<script lang="ts" setup>
import { useMaxHeightAnimator } from '~/composables/general/useMaxHeightAnimator';

const productPageStore = useMyProductPageStore();

const quantityDescCopy = computed(
  () => productPageStore.currentVariant?.StockQuantityDescription,
);
const savingsCopy = computed(
  () => productPageStore.currentTotalSavingsToDisplay,
);

const {
  setElementHeightCallback,
  animatedElementTransitionClasses,
  animatedElementRootClass,
} = useMaxHeightAnimator({ listenToResize: true });

watch([quantityDescCopy, savingsCopy], () => {
  setElementHeightCallback();
});
</script>

<style lang="scss" scoped></style>
